<template>
	<div>
		<div class="center center-padding" style="">


			<div id="header-fixed" style="border:0px solid transparent;background: white;">

				<h3 style="padding-top:10px;">Återförsäljare</h3>

				<div style="background:var(--grey-3);padding:5px;border-radius: 5px;">


					<div class="af-header" style="">

						<!-- sök postnummer -->
						<div class="flexcenter" style="background: white;padding:5px;border-radius: 5px;align-items:start;">
							<Circle fileName="w3_location_light" size="40px" padding="20%" color="white" />
							<div class="flexcenter" style="flex-direction: column;align-items: start;margin-left:5px;">
								<b style="font-size:80%;color:grey;">Hitta din närmaste butik</b>
								<div class="flexcenter"
									style="background:white;border:1px solid var(--grey-5);padding:3px;border-radius: 5px;margin-top:3px;width:calc(100% - 10px);">
									<input type="text" v-model.number="this.postalCode" placeholder="Postnummer"
										style="border:0px solid transparent;outline: none;width:100%;" />
									<Circle fileName="w3_close_white" color="--grey-6" padding="25%" size="15px"
										@click="this.postalCode = '' " />
								</div>
							</div>
						</div>

						<!-- sök fritext -->
						<div class="flexcenter" style="background: white;padding:5px;border-radius: 5px;align-items:start;">
							<Circle fileName="w3_search_light" size="40px" padding="20%" color="white" />
							<div class="flexcenter" style="flex-direction: column;align-items: start;margin-left:5px;">
								<b style="font-size:80%;color:grey;">Fritextsök bland butiker</b>
								<div class="flexcenter"
									style="background:white;border:1px solid var(--grey-5);padding:3px;border-radius: 5px;margin-top:3px;width:calc(100% - 10px);">
									<input type="text" v-model.number="this.postalCodeFilter" placeholder="Sök..."
										style="border:0px solid transparent;outline: none;width:100%;" />
									<Circle fileName="w3_close_white" color="--grey-6" padding="25%" size="15px"
										@click="this.postalCodeFilter = ''" />
								</div>
							</div>
						</div>

						<!-- bli åf -->
						<div class="flexcenter link"
							style="background: white;padding:5px;border-radius: 5px;align-items:start;padding-right:10px;"
							@click="this.callBoove()" title="Ring till oss!">
							<Circle fileName="w3_phone_light" size="40px" padding="20%" color="white" />
							<div class="flexcenter" style="flex-direction: column;align-items: start;margin-left:5px;">
								<b style="font-size:80%;color:grey;">Vill du bli återförsäljare?</b>
								<h3 style="color:var(--grey-5);">08-761 02 66</h3>
							</div>
						</div>







					</div>

					<div class="flexcenter" style="margin-top:10px;">
						<div class="filter link" :class="this.postalCodeFilterMc ? 'selected' : '' "
							@click="this.postalCodeFilterMc = !this.postalCodeFilterMc">
							MC
						</div>
						<div class="filter link" :class="this.postalCodeFilterCykel ? 'selected' : ''"
							@click="this.postalCodeFilterCykel = !this.postalCodeFilterCykel">CYKEL
						</div>
						<div class="filter link" :class="this.postalCodeFilterBil ? 'selected' : ''"
							@click="this.postalCodeFilterBil = !this.postalCodeFilterBil">BIL
						</div>


						<Button v-if="!this" label="ALLA" :class="!this.hasFilter ? '' : 'grey'" @click="this.allFilterClicked()" />
					</div>

					<!-- lista med snabblänkar -->
					<div v-if="!this.postalCode" class="flexcenter"
						style="flex-wrap:wrap;overflow:scroll;margin-top:10px;margin-bottom:10px;">
						<div v-for="letter in this.resellerModel.keys()" :key="letter" class="flexcenter link letter"
							@click="this.letterClicked(letter)" style="">
							<div style="width:100%;text-align: center;font-weight: bold;">
								{{ letter }}
							</div>


						</div>
					</div>

				</div>

				<div style="margin-top:10px;margin-bottom:10px;">
					<b style="color:grey;">{{ this.resultLabel }}</b>
				</div>





				<div ref="fromtop" id="fromtop" style="display: block;height:1px;background:transparent; ">&nbsp;</div>
				<!-- för att beräkna hur man ska scrolla -->
			</div>

			<!-- lista med index-bokstav -->
			<div id="letter-list" v-if="!this.postalCode">
				<div v-for="letter in this.resellerModel.keys()" :key="letter" class="flexcenter letter-div" :ref="letter"
					style="padding:0px;margin-right:10px;align-items:start;scroll-margin-top: 0px;">

					<div class="flexcenter"
						style="min-width:30px;width:30px;height:30px;background: var(--grey-4);border-radius: 50%;">
						<div style=" width:100%;text-align: center;font-weight: bold;font-size:100%;">{{ letter }}</div>
					</div>

					<div style="border:0px solid blue;flex-grow:1;margin-left:5px;">
						<ResellerRow v-for="reseller in this.resellerModel?.get(letter)" :key="reseller.resellerId"
							:reseller="reseller" />


					</div>

				</div>
			</div>

			<!-- postnummer sökning -->
			<div v-if="this.postalCode" class="flexcenterx" style="flex-wrap:wrap;">
				<ResellerRow v-for="reseller in this.resellerList" :key="reseller.resellerId" :reseller="reseller" />
			</div>
		</div>
		<div v-if="this.showBottomBar" class="flexcenter bottom-bar center center-padding" style="justify-content: end;"
			@click="this.scrollToTop()">
			<Circle fileName="w3_chevron_up_white" color="--bg-message" padding="20%" hover="" />
		</div>

	</div>
</template>
<script>
import { STORE_GETTER } from '../../store/store';
import ResellerRow from './ResellerRow.vue';
import { webContentMixin } from "@/mixins/webContentMixin.js";

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
import { resellerListMixin } from "@/mixins/resellerListMixin.js";

export default {
	name: "ResellerView",
	components: { ResellerRow  },
	mixins: [webContentMixin, resellerListMixin],
	props: {

	},
	data() {
		return {
			showBottomBar: false


		};
	},
	computed: {

	


		baseModel() {
			return this.$store.getters[STORE_GETTER.BASE_MODEL]
		},

		

	},
	watch: {

		postalCode: function () {
			this.postalCodeFilter = null;
			window.scrollTo({ top: 0, behavior: 'smooth' });
		},

		postalCodeFilter: function(){
			this.postalCode = null;
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}

		//postalCodeFilterInput: function (postalCodeFilter) {
		//	console.log("FP: watcher: ", postalCodeFilter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });
		allFilterClicked(){
			this.postalCodeFilterBil = false;
			this.postalCodeFilterCykel = false;
			this.postalCodeFilterMc = false;
		},
		letterClicked(letter){

			const fromtop = this.$refs["fromtop"];

			const div = this.$refs[letter][0];


			if (fromtop && div){
				let y = div.offsetTop - (fromtop.getBoundingClientRect().top + 1);	
				window.scrollTo({ top: y, behavior: "smooth" });
				//document.body.scrollTo({ top: y, behavior: "smooth" })
				
			}
			//

				// FP: SC window.scrollTo({ top: y, behavior: 'smooth' });
				//ocument.scrollingElement.scrollTo({ top: y, behavior: 'smooth' });
				//document.body.scrollTo({ top: y, behavior: "smooth" })

				/*if (document.body.scrollTop){
					document.body.scrollTo({ top: y, behavior: "smooth" })
				}else{
					document.scrollingElement.scrollTo({ top: y, behavior: 'smooth' });
				}*/

				//this.getScroller()?.scrollTo({ top: y, behavior: 'smooth' });

				/*if (document.body.scrollTop){
	document.body.scrollTo({ top: y, behavior: "smooth" })
}else{
	document.scrollingElement.scrollTo({ top: y, behavior: 'smooth' });
}*/
					

		},
		scrollToTop(){
			//window.scrollTo({	top: 0, behavior: "smooth" })
			//document.body.scrollTo({ top: 0, behavior: "smooth" })

			window.scrollTo({ top: 0, behavior: "smooth" });
			/*
			if (document.body.scrollTop){
				document.body.scrollTo({ top: 0, behavior: "smooth" });
			}else{
				
			}*/

				
		},
		handleScroll() {

			// FP: SC this.showBottomBar = window.scrollY > 1000
			//this.showBottomBar = this.getScroller().scrollTop > 1000
			this.showBottomBar = window.scrollY > 1000
		},
		/*getScroller() {
			if (document.body.scrollTop > 0) return document.body;
			if (document.documentElement.scrollTop > 0) return document.documentElement;
			return document.scrollingElement || document.documentElement;
		},*/


	},
	mounted() {
		// FP: SC window.addEventListener("scroll", this.handleScroll)
		document.addEventListener("scroll", this.handleScroll, { passive: false })
		//document.body.addEventListener("scroll", this.handleScroll, { passive: false })
		
	},
	beforeUnmount() {
		// FP: SC window.removeEventListener("scroll", this.handleScroll)
		document.removeEventListener("scroll", this.handleScroll)
		//document.body.removeEventListener("scroll", this.handleScroll)
	},
};
</script>

<style scoped>
div.site.login div#header-fixed {
	top: var(--top-header-height-login);
}

div.site.logout div#header-fixed {
	top: var(--top-header-height-logout);
}

div#header-fixed{
	position: sticky;
}

@media (max-width: 768px) {

	div#header-fixed {
			position: initial;
		}
	
}


div.letter-div{

}

div.af-header{
	align-items: stretch;
	display: flex;
	gap:5px;
	flex-direction: row;

}

@media (max-width: 768px) {

div.af-header {
		align-items: stretch;
		display: flex;
		gap: 5px;
		flex-direction: column;

	}

}

div.filter{
	background: white;
	padding:5px;
	padding-left:10px;
	padding-right: 10px;
	border-radius: 5px;
	font-weight: bold;
	font-size: 90%;

}

div.filter:hover {
	background: var(--grey-4);

}

div.filter.selected {
	background: var(--grey-4);
	background: var(--bg-message);
	color:white; 

}

div.letter{
	padding: 0px;
		background: white;
		min-width: 30px;
		width: 30px;
		height: 30px;
		margin-bottom: 5px;
		border-radius: 50%;
		
}

div.letter:hover {
	background: var(--grey-4);
}

.bottom-bar {
	position: sticky;
	bottom: 0;
	width:calc(100% - 60px);
	background: transparent;
	color: white;
	padding: 15px;
	text-align: right;
	z-index:10;
}



</style>